import Vue from 'vue'

const state = Vue.observable({
  currentKey: null,
  currentComp: null,
  currentProps: {},
  showLeftBoard: false,
  showRightBoard: false,
})

const registry = {}

export function register(key, component) {
  registry[key] = component
}

export const panelStore = {
  open(key, props = {}) {
    this.close()
    state.showLeftBoard = false
    state.showRightBoard = false
    const comp = registry[key]
    if (!comp) {
      if (key === 'showComprehensiveMonitoring') return this.open('monitoring')
      if (key === 'showWaterSupplyScale') return this.open('waterSupply')
      if (key === 'showWaterDistributionLines') return this.open('scheduling')
      if (key === 'handleSmartConstruction') return this.open('construction')
      if (key === 'handleMaintenance') return this.open('maintenance')
      if (key === 'handleEmergency') return this.open('emergency')
      if (key === 'handleProjectManagement') return this.open('project')
      if (key === 'handleOperationDispatch') return this.open('notice')
      if (key === 'exitSystem') { this.close(); return }
      console.warn('[panelStore] 未注册的面板:', key)
      return
    }
    state.currentKey = key
    state.currentComp = comp
    state.currentProps = props
  },

  close() {
    state.currentKey = null
    state.currentComp = null
    state.currentProps = {}
  },

  toggle(key, props) {
    if (state.currentKey === key) {
      this.close()
    } else {
      this.open(key, props)
    }
  },

  toggleLeftBoard() { state.showLeftBoard = !state.showLeftBoard },
  toggleRightBoard() { state.showRightBoard = !state.showRightBoard },
  setLeftBoard(val) { state.showLeftBoard = val },
  setRightBoard(val) { state.showRightBoard = val },

  get currentKey() { return state.currentKey },
  get currentComp() { return state.currentComp },
  get currentProps() { return state.currentProps },
  get showLeftBoard() { return state.showLeftBoard },
  get showRightBoard() { return state.showRightBoard },
}
